// ImageDetails.js
import Image from 'next/image';
import DetailsComponent from "@/components/ui/cards/DetailsComponent";
import styles from "@/components/ev-details/ImageDetails.module.css";

const ImageDetails = ({ images, make, model }) => {
  const hasImages = Array.isArray(images) && images.length > 0;
  const imageUrl = hasImages ? images[0].image_url : '/illustrations/v2/EV-v1.png';
  const imageAltText = `${make} ${model}`;
  const imageClassName = hasImages ? styles.evImage : styles.fallBackImage;
  const containerClassName = hasImages ? styles.imageContainer : styles.fallbackImageContainer;

  return (
    <DetailsComponent title="Image">
      <div className={containerClassName}>
        <img
          src={imageUrl}
          alt={imageAltText}
          className={imageClassName}
        />
      </div>
    </DetailsComponent>
  );
};

export default ImageDetails;
